<div class="library-details" [class.opened]="libraryItem">
  @if (libraryItem) {
    <div class="library-details-overlay"></div>
  }
  <div class="library-sidebar">
    @if (libraryItem) {
      <ng-scrollbar class="library-sidebar-scrollbar">
        <div class="library-sidebar-block library-sidebar-title-block">
          <div class="library-sidebar-title">
            <lib-library-item-icon class="library-icon" [item]="libraryItem" [size]="24"></lib-library-item-icon>
            {{ libraryItem.name }}
          </div>
  
          <button class="button button--icon" mat-icon-button aria-label="Close" (click)="close()">
            <lib-icon icon="x" [size]="20"></lib-icon>
          </button>
        </div>
        <div class="library-sidebar-block library-sidebar-image-block">
          <div
            class="library-image-preview"
            [cropImage]="previewImage | preSignedUrl : entityTypeId.NODE : bundleType.LIBRARY : fieldName | async"
            [imageWidth]="1200">
            @if (!previewImage) {
              <lib-library-item-icon class="library-icon" [item]="libraryItem"></lib-library-item-icon>
            }
          </div>
        </div>
        @if (libraryItem.userPin) {
          <div class="library-sidebar-pinned-wrapper">
            <div class="library-sidebar-pinned">
              <lib-icon icon="push-pin"></lib-icon> {{'LIBRARY.pinned' | translate}}
            </div>
          </div>
        }
        @if (libraryItem.description) {
          <div class="library-sidebar-block">
            <h6 class="library-sidebar-block-title">
              {{ 'COMMON.description' | translate }}
            </h6>
            <p class="library-description-paragraph" [innerHTML]="libraryItem.description | safeHtml"></p>
          </div>
        }
        @if (libraryItem.publicTags?.length) {
          <div class="library-sidebar-block">
            <h6 class="library-sidebar-block-title">
              {{ 'LIBRARY_PAGE.tags' | translate }}
            </h6>
            <lib-chips [items]="libraryItem.publicTags"></lib-chips>
          </div>
        }
        <div class="library-sidebar-block">
          <h6 class="library-sidebar-block-title">
            {{ 'LIBRARY_PAGE.details' | translate }}
          </h6>
          <div class="library-details-list">
            <div class="library-details-item">
              <span class="library-details-label">{{ 'LIBRARY_PAGE.type' | translate }}</span>
              <span class="library-details-value">{{ libraryItem.file?.extension || libraryItem.type }}</span>
            </div>
            @if (libraryItem.file) {
              <div class="library-details-item">
                <span class="library-details-label">{{ 'LIBRARY_PAGE.size' | translate }}</span>
                <span class="library-details-value">{{ +libraryItem.file.fileSize | fileSize }}</span>
              </div>
            }
            @if (!hideUpdatedDate) {
              <div class="library-details-item">
                <span class="library-details-label">{{ 'LIBRARY_PAGE.last_modified' | translate }}</span>
                <span class="library-details-value">{{ libraryItem.updated | customDate }}</span>
              </div>
            }
            @if (!hideCreatedDate) {
              <div class="library-details-item">
                <span class="library-details-label">{{ 'LIBRARY_PAGE.created' | translate }}</span>
                <span class="library-details-value">{{ libraryItem.created | customDate }}</span>
              </div>
            }
          </div>
        </div>
        @if (libraryItem.file) {
          <div class="library-sidebar-block library-sidebar-actions-block">
            @if (allowDownload) {
              <button mat-flat-button class="button button--transparent library-sidebar-button" (click)="download.emit(libraryItem)">
                <lib-icon icon="download-simple" [size]="20"></lib-icon>
                {{ 'LIBRARY_PAGE.download' | translate }}
              </button>
            }
            <button mat-flat-button class="button button--transparent library-sidebar-button" (click)="preview.emit(libraryItem)">
              <lib-icon icon="eye" [size]="20"></lib-icon>
              {{ 'LIBRARY_PAGE.preview' | translate }}
            </button>
          </div>
        }
      </ng-scrollbar>
    }
  </div>
</div>
